import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapse as MuiCollapse, IconButton as MuiIconButton, } from '@mui/material';
import { Fragment, useState } from 'react';
import { styled } from '../../utils';
import { CardRow } from '../Card';
import { Icon } from '../Icon';
export function Collapsable(props) {
    const [open, setOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(CardRowNestedToggleStyled, { label: _jsxs(Fragment, { children: [_jsx(MuiIconButton, { onClick: () => setOpen(!open), children: open ? (_jsx(Icon, { variant: "arrow-down-2" })) : (_jsx(Icon, { variant: "arrow-right-2" })) }), props.label] }), value: props.value }), _jsx(MuiCollapse, { in: open, timeout: "auto", unmountOnExit: true, children: props.items.map((x, i) => (_jsx(CardRowNestedStyled, { label: x.label, value: x.value }, i))) })] }));
}
const CardRowNestedStyled = styled(CardRow)(({ theme }) => ({
    padding: theme.spacing(1.25, 2, 1.25, 2),
}));
const CardRowNestedToggleStyled = styled(CardRow)(({ theme }) => ({
    paddingRight: theme.spacing(2),
}));
